<template>
  <div>
    <div
      class="alert alert-warning border-0 text-center mt-1 align-items-center justify-content-center position-relative"
      role="alert"
      v-show="closeModal"
    >
      <i class="material-icons pr-2" style="font-size: 3em">info</i>
      <p style="text-align: center">PÁGINA EM MANUTENÇÃO!</p>
      <br />
      <p style="text-align: center">
        Estamos trabalhando para resolvermos o mais breve possível.
      </p>
      <br />
      <p style="text-align: center">
        Para solicitações, entre em contato conosco através dos canais abaixo:
      </p>
      <p style="text-align: center">- Telefone: (31) 3249-1666</p>
      <p style="text-align: center">- WhatsApp: (31) 3249-1666</p>
      <p style="text-align: center">- E-mail: relacionamento@cdlbh.com.br</p>
      <p style="text-align: center">- Chat: cdlbh.com.br</p>
      <p style="text-align: center">
        Nosso horário de funcionamento é das 8h às 19h, de segunda à sexta e de
        08h às 14h aos sábados e feriados.
      </p>
    </div>
    <form
      class="form_padrao pt-2"
      action
      @submit.prevent="abrirChamado"
      v-show="statusManutencao"
    >
      <div class="form-row">
        <div class="form-group flutuante col-md-12">
          <input
            type="text"
            name="nomeOperador"
            id="nomeOperador"
            required
            v-model="operador.nome"
          />
          <label for="nomeOperador">Nome do Beneficiário</label>
        </div>
        <div class="form-group flutuante col-md-6">
          <the-mask
            type="text"
            name="cpf"
            id="cpf"
            v-model="operador.cpf"
            required
            :mask="['###.###.###-##']"
          />
          <label for="cpf">CPF</label>
        </div>
        <div class="form-group flutuante col-md-6">
          <select
            name="movimentacaoTipo"
            id="movimentacaoTipo"
            v-model="operador.operadora"
            placeholder="Selecione"
          >
            <option value selected disabled>Selecione...</option>
            <option value="197">Unimed</option>
            <option value="227">Premium Saúde</option>
            <option value="198">Vitallis</option>
            <option value="199">Belo Dente</option>
            <option value="200">Odontoprev</option>
          </select>
          <label for="movimentacaoTipo" v-if="!operador.operadora"
            >Operadora</label
          >
        </div>
        <div class="form-group flutuante col-md-6">
          <input
            type="email"
            name="emailContato"
            id="emailContato"
            v-model="operador.email"
            required
          />
          <label for="emailContato">E-mail de Contato</label>
        </div>
        <div class="form-group flutuante col-md-6">
          <the-mask
            type="text"
            name="telefoneContato"
            id="telefoneContato"
            required
            :mask="['(##) ####-####', '(##) #####-####']"
            v-model="operador.telefone"
          />
          <label for="telefoneContato">Telefone</label>
        </div>
        <div class="form-group flutuante col-md-12">
          <input
            type="text"
            name="enderecoDeEntrega"
            id="enderecoDeEntrega"
            v-model="operador.enderecoDeEntrega"
            required
          />
          <label for="enderecoDeEntrega">Endereço de Entrega</label>
        </div>
        <div class="form-group col-md-12">
          <div class="form-check">
            <input
              type="checkbox"
              id="ciente"
              v-model="operador.ciente"
              name="ciente"
            />
            <label for="ciente" class
              >Estou ciente que serei cobrado pelo valor da segunda via (R$
              17,00) na próxima fatura.<br />
              Caso o cartão tenha sido furtado, a taxa será isenta.</label
            >
          </div>
        </div>
      </div>
      <div class="form-row">
        <div
          class="form-group col-md-3 d-flex flex-row justify-content-end align-items-end"
        >
          <button
            type="submit"
            class="btn btn-verde p-0 fit-content"
            :disabled="loading"
          >
            <span
              class="spinner-grow spinner-grow-sm pr-2"
              role="status"
              aria-hidden="true"
              v-show="loading"
            ></span>
            <span v-if="loading">Enviando</span>
            <span v-else>enviar Solicitação</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
export default {
  name: "viacartao",
  components: {
    TheMask,
  },
  data() {
    return {
      produto: {
        nome: "2ª via do Cartão de Saúde",
        id: "Carteirinha",
      },
      loading: false,
      operador: {
        nome: null,
        email: null,
        telefone: null,
        cpf: null,
        operadora: null,
        ciente: null,
        enderecoDeEntrega: null,
      },
      closeModal: false,
      statusManutencao: false,
      breadcrumb: [
        {
          // nome: "2ª via do Cartão de Saúde",
          nome: "CDL Saúde",
          id: "Carteirinha",
        },
      ],
    };
  },
  methods: {
    abrirChamado() {
      if (this.operador.ciente) {
        this.loading = true;
        this.$http
          .post("/api/Ssm/RegistrarChamadoServicos", {
            idItemDeCatalogo: parseInt(this.operador.operadora),
            motivo: `Nome: ${this.operador.nome}-Email: ${this.operador.email}-Telefone: ${this.operador.telefone}-CPF: ${this.operador.cpf} -operadoraID: ${this.operador.operadora} -Endereco: ${this.operador.enderecoDeEntrega}`,
          })
          .then((response) => {
            this.loading = false;
            this.$toast.open({
              message: response.data.message,
              type: "success",
            });
            this.operador = {};
          })
          .catch(() => {
            this.loading = false;
            this.$toast.open({
              message: "Erro no envio da solicitação, tente novamente.",
              type: "error",
            });
          });
      } else {
        this.$toast.open({
          message:
            "Você precisa marcar a opção que esta ciente para prosseguir.",
          type: "error",
          duration: 4000,
        });
      }
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped></style>
